import { render, staticRenderFns } from "./CardTransportCompany.vue?vue&type=template&id=019966b3&scoped=true&"
import script from "./CardTransportCompany.vue?vue&type=script&lang=js&"
export * from "./CardTransportCompany.vue?vue&type=script&lang=js&"
import style0 from "./CardTransportCompany.vue?vue&type=style&index=0&id=019966b3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019966b3",
  null
  
)

export default component.exports